import {createItem, removeItem, ItemOption} from "@components/items/selected-tag-item/selected-tag-item"

const initFilterList = () => {
  const filterLists = document.querySelectorAll<HTMLElement>(".js-filter-list")

  filterLists.forEach((list) => {
    if (!list.dataset.filterTarget) return;

    const targetedForm = document.querySelector<HTMLFormElement>(`#${list.dataset.filterTarget}`)
    const targetedCategoryForm = document.querySelector<HTMLFormElement>(".f-category")
    const inputs = targetedForm?.querySelectorAll<HTMLInputElement>("input")
    const categories = targetedCategoryForm?.querySelectorAll<HTMLInputElement>("input")
    const template = list.querySelector<HTMLTemplateElement>("template")

    if (!template || !targetedForm || !inputs) return

    const checkboxEval = (input: HTMLInputElement, itemOption: ItemOption) => {
      if (input.checked) createItem(itemOption, template, list)
      else removeItem(input.id, list)
    }

    const radioEval = (input: HTMLInputElement, itemOption: ItemOption) => {
      if (input.checked) createItem(itemOption, template, list)
      else removeItem(input.id, list)
    }

    const rangeEval = (input: HTMLInputElement) => {
      const rangeWrapper = input.closest<HTMLElement>(".f-range-slider")
      const rangeWrapperInputs = rangeWrapper?.querySelectorAll<HTMLInputElement>(".f-range-slider__range")

      if (!rangeWrapper || !rangeWrapperInputs) return

      let create = false
      let title = ""
      rangeWrapperInputs.forEach((input, index) => {
        if (input.value != input.max && input.value != input.min) create = true
        title += `${input.value} ${rangeWrapperInputs.length - 1 != index ? "- " : ""}`
      })

      if (create)
        createItem(
          {
            value: title,
            title: title,
            id: rangeWrapper.id,
            prefix: rangeWrapper.dataset.filterPrefix,
            suffix: rangeWrapper.dataset.filterSuffix,
          } as ItemOption,
          template,
          list,
        )
      else removeItem(rangeWrapper.id, list)
    }

    const inputTypeEval = (input: HTMLInputElement) => {
      const itemOption = {
        value: input.value,
        title: input.dataset.filterTitle,
        id: input.id,
        prefix: input.dataset.filterPrefix,
        suffix: input.dataset.filterSuffix,
      } as ItemOption

      if (input.type === "checkbox") checkboxEval(input, itemOption)
      else if (input.type === "radio") radioEval(input, itemOption)
      else if (input.closest(".f-range-slider")) rangeEval(input)
    }

    inputs.forEach((input) => {
      input.addEventListener("change", () => {
        inputTypeEval(input)
      })

      input.addEventListener('clear', () => {
        if(input.type === "checkbox") input.checked = false;
        else input.value = "";

        input.dispatchEvent(new Event("change"))
      })

      inputTypeEval(input)
    })

    categories?.forEach((category) => {
      category.addEventListener("change", () => {
        inputTypeEval(category)
      })

      category.addEventListener('clear', () => {
        category.checked = false;

        category.dispatchEvent(new Event("change"))
      })

      inputTypeEval(category)
    })
  })
}

initFilterList()
document.addEventListener("filterListReinit", initFilterList)

